/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Back_To_BlogInputs */

const en_blog_back_to_blog = /** @type {(inputs: Blog_Back_To_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to blog`)
};

const zh_blog_back_to_blog = /** @type {(inputs: Blog_Back_To_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回博客`)
};

/**
* | output |
* | --- |
* | "Back to blog" |
*
* @param {Blog_Back_To_BlogInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_back_to_blog = /** @type {((inputs?: Blog_Back_To_BlogInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Back_To_BlogInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_back_to_blog(inputs)
	return zh_blog_back_to_blog(inputs)
});
export { blog_back_to_blog as "blog.back_to_blog" }